import { Injectable } from '@angular/core';
import { WorkflowVertex, WorkflowVertexLibrary } from 'component.workflow.core';
import { Dictionary } from 'buzzyears.core';
import { WorkflowGraphVertexInteractionPoint } from './vertex/interaction-point/workflow-graph-vertex-interaction-point';

@Injectable()
export class WorkflowGraphService {

  protected vertexLibrary: WorkflowVertexLibrary;
  protected incomingInteractionPoints = new Dictionary<WorkflowGraphVertexInteractionPoint>();
  protected outgoingInteractionPoints = new Dictionary<WorkflowGraphVertexInteractionPoint>();

  static getVertexInteractionPointKey(vertex: WorkflowVertex, key: string = null) {

    if (!key) {
      key = '*';
    }

    return `${vertex.key}->${key}`;
  }

  constructor() {
    this.vertexLibrary = new WorkflowVertexLibrary(80);
  }

  getLibrary(): WorkflowVertexLibrary {
    return this.vertexLibrary;
  }

  protected getInteractionPointsStore(direction: string): Dictionary<WorkflowGraphVertexInteractionPoint> {
    return direction === 'in' ? this.incomingInteractionPoints : this.outgoingInteractionPoints;
  }

  unRegisterIOPoint(uiPoint: WorkflowGraphVertexInteractionPoint, direction: string) {
    const vertex = uiPoint.vertex,
      point = uiPoint.point,
      key = point.named ? point.key : null;

    this.getInteractionPointsStore(direction).remove(WorkflowGraphService.getVertexInteractionPointKey(vertex, key));
  }

  getInlet(vertex: WorkflowVertex, inletKey: string = null): WorkflowGraphVertexInteractionPoint {
    const key = WorkflowGraphService.getVertexInteractionPointKey(vertex, inletKey);
    return this.incomingInteractionPoints.get(key);
  }

  getOutlet(vertex: WorkflowVertex, outletKey: string = null): WorkflowGraphVertexInteractionPoint {
    const key = WorkflowGraphService.getVertexInteractionPointKey(vertex, outletKey);
    return this.outgoingInteractionPoints.get(key);
  }

  registerIOPoint(uiPoint: WorkflowGraphVertexInteractionPoint, direction: string) {
    const vertex = uiPoint.vertex,
      point = uiPoint.point,
      key = point.named ? point.key : null;

    this.getInteractionPointsStore(direction).set(WorkflowGraphService.getVertexInteractionPointKey(vertex, key), uiPoint);
  }
}



// WEBPACK FOOTER //
// ./src/library/graph/workflow-graph.service.ts